import React, { useEffect } from 'react';
import Header from './Header';
import TinderCards from './TinderCards';
import './App.css';
import Info from './Info';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {

  // useEffect(() => {
  //   new Audio ('https://firebasestorage.googleapis.com/v0/b/humble-2b891.appspot.com/o/My_movie.mp3?alt=media&token=405eda5b-eb72-4e03-b6d4-b06541b49e9a').play();
  // }, [])

  return (
    <div className="App">
      <Router>
      <Header />
        <Routes>
          <Route path='/' element={<Info/> }/>
          <Route path='/info' element= {<TinderCards />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
